// Módulo para obtener suprazones
/* eslint-disable */
import axios from 'axios'

const baseUrl = process.env.VUE_APP_BASE_API + '/excursion/pickupzones/'

const state = {
  pickupzones: [],
  pickupzonesListAdmin: []
}

const actions = {

  async loadPickupzonesBySuprazone({
    commit
  }, suprazoneId) {
    await axios
      .get(baseUrl + '?supra_zone=' + suprazoneId)
      .then(response => {
        commit('SET_PICKUPZONES_LIST_ADMIN', response.data)
      })
  },

  async createPickupzone({
    commit, dispatch
  }, data) {
    await axios
      .post(baseUrl, data.payload)
      .then( response => {
        dispatch('loadPickupzonesBySuprazone', data.suprazone_id)
        return response.data
      })
  },

  async updatePickupzone({
    commit, dispatch
  }, data) {
    await axios
      .patch(baseUrl + data.pickupzone_id + '/', data.payload)
      .then(response => {
        dispatch('loadPickupzonesBySuprazone', data.suprazone_id)
        return response.data
      })
  },

  async deletePickupzone({
    commit, dispatch
  }, data) {
    return axios
      .delete(baseUrl + data.pickupzone_id + '/')
      
  }

}

const mutations = {

  SET_PICKUPZONES(state, pickupzones) {
    state.pickupzones = pickupzones
  },
  SET_PICKUPZONES_LIST_ADMIN(state, pickupzones) {
    state.pickupzonesListAdmin = pickupzones
  },
  RESET_PICKUPPOINTS_LIST_ADMIN(state) {
    state.pickupzonesListAdmin = []
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
